// extracted by mini-css-extract-plugin
export default {"card":"ErrorNofication_card__Nv3vd","card-title":"ErrorNofication_card-title__mtBkC"};